// ===========================================
// ADMIN UI SLICE
// ===========================================

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Admin UI state for sidebar and layout management
 */
interface AdminUiState {
  sidebarCollapsed: boolean;
  sidebarMobileOpen: boolean;
}

const initialState: AdminUiState = {
  sidebarCollapsed: false,
  sidebarMobileOpen: false,
};

/**
 * Admin UI slice
 * Manages admin dashboard UI state
 */
const adminUiSlice = createSlice({
  name: 'adminUi',
  initialState,
  reducers: {
    toggleAdminSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setAdminSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
    toggleAdminMobileSidebar: (state) => {
      state.sidebarMobileOpen = !state.sidebarMobileOpen;
    },
    setAdminMobileSidebar: (state, action: PayloadAction<boolean>) => {
      state.sidebarMobileOpen = action.payload;
    },
  },
});

export const {
  toggleAdminSidebar,
  setAdminSidebarCollapsed,
  toggleAdminMobileSidebar,
  setAdminMobileSidebar
} = adminUiSlice.actions;
export const adminUiReducer = adminUiSlice.reducer;
